import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { parseQueryParamsObject } from "@robe/core-utils";
import { ContentTypeSimplified } from "@robe/core-types";

export interface GetSimplifiedContentTypesOptions {
  ids?: string[];
}

export const getSimplifiedContentTypes = (
  core: XcoreCore,
  options?: GetSimplifiedContentTypesOptions
): BaseApiRequest<Array<ContentTypeSimplified>> =>
  core
    .fetch(`/api/content-types/simplified${parseQueryParamsObject(options)}`)
    .then<Array<ContentTypeSimplified>>((res) => res.json())
    // There are still more fields than needed, so map only the used ones
    .then<Array<ContentTypeSimplified>>((res) => res.map(({ id, name, locales, single }) => ({ id, name, locales, single })));
